module.exports = __webpack_public_path__ + "static/media/image-5.135a0ba7.png";